import(/* webpackMode: "eager" */ "/root/src/app/global-error.tsx");
